import { h } from "preact";

export default function LoadingContentPreloader() {
  return (
    <div className="loading-content">
      <div id="feed-loading" className="spnf_newsfeed-loader">
        <div className="spnf_message">
          <div className="spnf_bars">
            <div className="spnf_first">
              <div className="spnf_bar" />
              <div className="spnf_bar" />
            </div>
            <div className="spnf_second">
              <div className="spnf_bar" />
            </div>
            <div className="spnf_third">
              <div className="spnf_bar" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
